/**
 * Modals Bridge
 *
 * Exposes React modals to legacy JavaScript code through window.CFN.modals API.
 * This provides a clean interface for legacy code to open/close React modals.
 *
 * Usage from legacy code:
 *   window.CFN.modals.uploads.open();
 *   window.CFN.modals.layerSelector.open();
 *   window.CFN.modals.routes.open();
 *   window.CFN.modals.ductView.open();
 *   window.CFN.modals.ductSearch.open();
 *   window.CFN.modals.polygonPopup.open({ feature, latlng, layerId });
 *   window.CFN.modals.confirm.open({ message, onConfirm, ... });
 *   window.CFN.modals.info.open({ message, onDismiss, ... });
 */
let modalAPI = null;
/**
 * Register the modal API from the ModalContext
 * Called by the HomeApp component after mounting
 */
export function registerModalsAPI(api) {
    modalAPI = api;
    // Expose to window.CFN for legacy code
    if (typeof window !== 'undefined') {
        window.CFN = window.CFN || {};
        window.CFN.modals = {
            uploads: {
                open: api.uploads.open,
                close: api.uploads.close,
            },
            layerSelector: {
                open: api.layerSelector.open,
                close: api.layerSelector.close,
            },
            routes: {
                open: api.routes.open,
                close: api.routes.close,
            },
            ductView: {
                open: api.ductView.open,
                close: api.ductView.close,
            },
            ductSearch: {
                open: api.ductSearch.open,
                close: api.ductSearch.close,
            },
            polygonPopup: {
                open: api.polygonPopup.open,
                close: api.polygonPopup.close,
            },
            confirm: {
                open: api.confirm.open,
                close: api.confirm.close,
            },
            info: {
                open: api.info.open,
                close: api.info.close,
            },
            conduitCreate: {
                open: api.conduitCreate.open,
                close: api.conduitCreate.close,
            },
        };
        console.log('✅ React modals bridge initialized');
        console.log('   Available: window.CFN.modals.uploads.open()');
        console.log('   Available: window.CFN.modals.layerSelector.open()');
        console.log('   Available: window.CFN.modals.routes.open()');
        console.log('   Available: window.CFN.modals.ductView.open()');
        console.log('   Available: window.CFN.modals.ductSearch.open()');
        console.log('   Available: window.CFN.modals.polygonPopup.open({ feature, latlng, layerId })');
        console.log('   Available: window.CFN.modals.confirm.open({ message, onConfirm, ... })');
        console.log('   Available: window.CFN.modals.info.open({ message, onDismiss, ... })');
        console.log('   Available: window.CFN.modals.conduitCreate.open({ layer, geom27700, geom4326, properties })');
    }
}
/**
 * Get the modals API (for use within React)
 */
export function getModalsAPI() {
    return modalAPI;
}
